/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Detail_Block_Tax_Country_BodyInputs */



/**
* | output |
* | --- |
* | "No tax country is set, so no tax regime can be determined and no invoice can be addressed." |
*
* @param {Partner_Detail_Block_Tax_Country_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_block_tax_country_body = /** @type {((inputs?: Partner_Detail_Block_Tax_Country_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Block_Tax_Country_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es ist kein Steuerland gesetzt, daher lässt sich kein Steuerregime bestimmen und keine Rechnung adressieren.")
	return /** @type {LocalizedString} */ ("No tax country is set, so no tax regime can be determined and no invoice can be addressed.")
});